import React from "react";
import styles from "./styles.module.less";
export function Video(props: {
    src: string;
}) {
    return <video src={props.src} playsInline={true} autoPlay={true} loop={true} muted={true} className={styles.video}/>;
}
